import {
  PassphraseVerificationSchema,
  type PassphraseVerification,
} from '@hedepy/common/schemas/routes/octopus/v1/encryption'

import { useApis } from '@/legacy-src/contexts/api-context'

import { fetchAuthorized, isFetchAuthorizedError } from '@/src/utils/fetchAuthorized'

import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const getGetAiPassphraseVerificationSWRKey = () => ['ai-passphrase-verification', 'GET'] as const

export const useGetAiPassphraseVerification = <
  Config extends SwrQueryOptions<PassphraseVerification | null> | undefined,
>(
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    getGetAiPassphraseVerificationSWRKey(),
    async () => {
      try {
        return await fetchAuthorized('/api/octopus/ai/passphrase/verify', api, { schema: PassphraseVerificationSchema })
      } catch (err) {
        if (isFetchAuthorizedError(err) && err.response.status === 404) {
          return null
        }

        throw err
      }
    },
    options,
  )
}
